import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import Dialog from '../../services/Dialogs'



const ModalAsignarSupervisorAsesor = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, asesor } = params


  const [ lista_supervisores, setLista_supervisores ] = useState<any>([])
  const [ envio_server, setSeEnvio ] = useState<boolean>(false)
  const cargarLista_supervisores = async()=>{
    try{
      setSeEnvio(true)
      let response : any = await RequestService.getEndPoint(`catalogos/listado_supervisores`)
      setLista_supervisores(response.data)
      setSeEnvio(false)
    }
    catch(e){
      setSeEnvio(false)
      toast.error('Problemas al intentar cargar')
    }
  }


  React.useEffect(() => {
    cargarLista_supervisores()
  }, []);





  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
          idsupervisor : yup.string(),
  });




  const enviarFormulario = async (registro:any,event:any) =>{
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro de la información?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.update( `supervisores/asignar_asesor/${asesor.uuid}` , { ...registro })

          if(res_){
            toast.success('La Supervisión fue actualizada correctamente')
            setTimeout(()=>{
              handleClose()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
            // console.log(e.response.data)
          } 
          
        }
       
  }








  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Selección de Supervisor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            JSON.stringify(asesor.idsupervisor)
          }

          {
            // JSON.stringify(lista_supervisores)
          }


                    <small>Asesor</small>
                    <p>{asesor.nombres} {asesor.paterno} {asesor.materno} </p>

                    <small>Gerente Actual</small>
                    { asesor.idgerente && ( <p>{asesor.idgerente.nombres} {asesor.idgerente.paterno} {asesor.idgerente.materno} </p> ) }
                    { !asesor.idgerente && ( <p>Actualmente no tiene un Gerente Asignado</p> ) }

                    <small>Sucursal</small>
                    <p>{asesor.idsucursal.nombre_sucursal}</p>




    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

            idsupervisor : !asesor.idsupervisor ? "" : asesor.idsupervisor.uuid,
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>


            <Form.Group className="mb-3" controlId="idsupervisor">
              <Form.Label>Supervisor</Form.Label>
              <Form.Select onChange={handleChange} value={values.idsupervisor} >
                <option value="">SIN SUPERVISOR ASIGNADO</option>
                {
                  lista_supervisores.map((supervisor:any,indice_supervisor:number)=><option value={supervisor.uuid}>{supervisor.nombres} {supervisor.paterno} {supervisor.materno} </option>)
                }
              </Form.Select>
              <Form.Control.Feedback type="invalid"> {<>{errors.idsupervisor}</>} </Form.Control.Feedback>
            </Form.Group>




        </Form>
      )}
    </Formik>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Asignar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalAsignarSupervisorAsesor;